import { render, staticRenderFns } from "./FSTPage.vue?vue&type=template&id=0d3876b0&scoped=true&"
import script from "./FSTPage.vue?vue&type=script&lang=js&"
export * from "./FSTPage.vue?vue&type=script&lang=js&"
import style0 from "./FSTPage.vue?vue&type=style&index=0&id=0d3876b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3876b0",
  null
  
)

export default component.exports